<template>
  <main class="input-wrap">
    <label v-if="label" @click="focusInput" class="input-label">{{
      label
    }}</label>
    <div
      class="input-wrapper"
      :class="{ invalid: invalid, 'input-wrapper--icon': icon }"
    >
      <span :class="iconName ? iconName : 'sienit'">{{ icon }}</span>
      <input
        :id="inputId"
        :type="type || 'text'"
        :placeholder="list && focused ? 'Търсене...' : placeholder"
        :value="list && focused ? search : getValue"
        :disabled="disabled"
        :autocomplete="autocomplete || 'new-password'"
        @focus="focused = true"
        @blur="(focused = false), (search = '')"
        @keyup="$emit('keyup')"
        @input="
          list
            ? updateSearch($event.target.value)
            : $emit('input', $event.target.value)
        "
      />

      <span v-if="disabled" class="disabled">A</span>
      <template v-if="list && !disabled">
        <span
          v-if="!value"
          class="sienit sienit__arrow"
          :class="{ 'sienit__arrow--open': focused }"
          >K</span
        >
        <span v-if="list && value" class="clear" @click="$emit('clear')"
          >F</span
        >
      </template>
    </div>
    <div
      class="new-input-dropdown"
      :class="{ 'new-input-dropdown-active': focused }"
      v-if="list"
    >
      <ul v-if="list && list.length > 0">
        <li
          v-for="(option, index) in filteredList"
          :key="index"
          :class="{ 'divider-item': option.type === 'divider' }"
          @mousedown="option.type !== 'divider' && selectOption(option)"
        >
          <hr v-if="option.type === 'divider'" />
          <span v-else> {{ prop ? option[prop] : option }}</span>
        </li>
      </ul>
      <ul v-else>
        <li>Няма резултати</li>
      </ul>
    </div>
  </main>
</template>

<script>
export default {
  props: [
    "label",
    "modelValue",
    "icon",
    "placeholder",
    "disabled",
    "invalid",
    "value",
    "type",
    "iconName",
    "list",
    "prop",
    "propValue",
    "autocomplete",
  ],
  data() {
    return {
      inputId: "input_" + Math.random().toString(36).substr(2, 9),
      focused: false,
      search: "",
    };
  },
  computed: {
    filteredList() {
      let output = this.list.filter((g) => {
        if (g.type === "divider") return g;
        else if (this.prop) {
          return g[this.prop].toLowerCase().includes(this.search.toLowerCase());
        } else {
          return g.toLowerCase().includes(this.search.toLowerCase());
        }
      });

      return output;
    },
    getValue() {
      if (this.value && this.propValue) {
        let val = this.list.find((x) => x[this.propValue] === this.value);
        return val ? val[this.prop] : "";
      } else if (this.prop && this.value) return this.value[this.prop];
      else return this.value;
    },
  },
  methods: {
    // replaced :for attribute with @click to focus the input element becouse of unwanted autocomplete issue
    focusInput() {
      const inputElement = document.getElementById(this.inputId);

      if (inputElement) {
        inputElement.focus();
      }
    },
    updateSearch(e) {
      this.search = e;
    },
    selectOption(option) {
      this.$emit("input", option);
    },
  },
};
</script>

<style scoped>
.input-wrap {
  position: relative;
}
</style>
